import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { HashRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { CalendarEventDetail } from "./components/calendarevents/CalendarEventDetail";
import { CardList } from "./components/cards/CardList";
import { CalendarList } from "./components/calendars/CalendarList";
import { ExerciseComponent } from "./components/exercise/ExerciseComponent";
import { ExerciseSelection } from "./components/exercise/ExerciseSelection";

const App: React.FC = () => {
    return (
        <div className="App">
            {/* <HeaderNavBar /> */}
            <div className="router-content">
                <Router>
                    <Switch>
                        <Route path="/calendars" component={CalendarList} />
                        <Route path="/event" component={CalendarEventDetail} />
                        <Route path="/cards" component={CardList} />
                        <Route path="/exercise" component={ExerciseComponent} />
                        <Route path="/exerciseSelection" component={ExerciseSelection} />

                        <Route path="*"><Redirect to="/exerciseSelection" /></Route>
                    </Switch>
                </Router>
            </div>
        </div>
    );
}

export default App;
